// Minai's storefront signals (Wave 6): one beacon when a product or article page is viewed and one when a form adds to the cart,
// sent to the campaign Worker through the app proxy. Nothing identifies the shopper: no cookie or id is made or read, and the
// Worker counts each address once per item a day (services/campaigns/merch-signals.js). Do Not Track and Global Privacy Control
// turn it off, and so do the theme editor and theme previews (only the published theme counts). The layout names the page in data-ns-signal: p<product id> or a<article id>.
export const SIGNAL_URL = '/apps/9space/signal';
const ID = /^[1-9]\d{0,19}$/;

export const optedOut = (nav, win) => nav.doNotTrack === '1' || win.doNotTrack === '1' || nav.globalPrivacyControl === true || Boolean(win.Shopify && (win.Shopify.designMode || (win.Shopify.theme && win.Shopify.theme.role && win.Shopify.theme.role !== 'main')));
export const viewBody = page => (/^[pa][1-9]\d{0,19}$/.test(page || '') ? { e: 'view', [page[0]]: page.slice(1) } : null);
export const isCartAdd = form => Boolean(form && form.getAttribute) && /\/cart\/add(\.js)?$/.test((form.getAttribute('action') || '').split('?')[0]);
// The variants a form adds: its id field (select, hidden or a picked radio) and each ticked items[][id] box, five at most.
export function cartBody(form) {
  const ids = [];
  for (const field of Array.from(form.elements || [])) {
    if (!(field.name === 'id' || /^items\[\d*\]\[id\]$/.test(field.name || '')) || !ID.test(field.value || '')) continue;
    if ((field.type === 'checkbox' || field.type === 'radio') && !field.checked) continue;
    if (!ids.includes(field.value)) ids.push(field.value);
  }
  return ids.length ? { e: 'cart', v: ids.slice(0, 5) } : null;
}

export function startSignals(doc = document, nav = navigator, win = window) {
  const script = doc.querySelector('script[data-ns-signal]');
  if (!script || typeof nav.sendBeacon !== 'function' || optedOut(nav, win)) return false;
  const send = body => { try { nav.sendBeacon(SIGNAL_URL, new Blob([JSON.stringify(body)], { type: 'text/plain' })); } catch {} };
  const view = viewBody(script.dataset.nsSignal);
  if (view) send(view);
  doc.addEventListener('submit', event => { const body = isCartAdd(event.target) && cartBody(event.target); if (body) send(body); }, true);
  return true;
}

if (typeof document !== 'undefined') startSignals();
